import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@ntuctech/devex-tangram/Box';

const FormElementSC = styled(Box)`
  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    margin-bottom: 1rem;
  }
`;

function FormElement({ children }) {
  return <FormElementSC mb={3}>{children}</FormElementSC>;
}

FormElement.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormElement;
